import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["width"];
const _hoisted_2 = ["href"];
import { computed, onBeforeMount, ref } from 'vue';
import { I18nInfo } from '@/user/models';
import store from '@/user/store';
import { Badge, SpriteIcons, TextButton, Pagination } from '@/user/components/common';
import { formatDate } from '@/user/helpers/util';
import moment from 'moment';
import { AccountService } from '@/user/apis/account/account.api';
import { clsx } from 'clsx';
import { UserLectureBlacklistModel } from '@/user/models/lecture/user-lecture-blacklist';
import { ErrorInfo } from '@/user/models/error-info';
import useFramedView from '@/user/components/FramedView';
const PAGE_SIZE = 5;
const DATE_FORMAT = 'YYYY.MM.DD';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LectureApplied',
    setup(__props) {
        useFramedView();
        const t = new I18nInfo('eduCenter.account');
        const t_common = new I18nInfo('common');
        const style = {
            section1: 'rounded-12 mt-16 flex gap-20 bg-gray-100 p-24 w-full',
            listWrap: 'w-full',
            listItem: 'whitespace-pre-wrap relative pl-16 before:content-["•"] before:absolute before:left-0 before:text-gray-800 text-gray-800 text-body-4',
            section2: 'mt-24 overflow-hidden rounded-12 border border-gray-250',
            table: 'w-full border-collapse',
            thWrapper: 'bg-gray-150',
            th: 'px-24 py-17 border-r-1 last:border-r-0 border-gray-250 text-body-3 text-gray-850',
            td: 'px-24 py-17 text-body-5 text-gray-700 border-t-1 border-r-1 last:border-r-0 border-gray-200',
            tdTitleWrapper: 'flex flex-col gap-6 cursor-pointer group',
            tdTitle: 'text-title-4 text-gray-900 line-clamp-2 group-hover:text-blue-700',
            withIcon: {
                wrapper: 'text-caption-1 flex items-center gap-4 group-hover:text-blue-700',
                wrapperCenter: 'text-caption-1 flex items-center gap-4 justify-center',
                icon1: 'text-gray-400 size-16 group-hover:text-blue-700',
                icon2: 'text-gray-600 size-20',
                iconRed: 'text-red-700 size-16',
                iconBlue: 'text-blue-700 size-16',
            },
            tdButtonWrapper: 'flex flex-col gap-8 items-center',
            textCenter: 'text-center',
            tdSupport: 'flex items-center gap-4',
            paginationWrapper: 'mt-24 flex justify-center',
            statusWrapper: 'flex items-center justify-center',
            endWrapper: 'flex items-center justify-center',
            subTitle: clsx('text-title-3', 'desktop:text-title-3'),
            noItem: 'flex items-center justify-center py-20 desktop:py-23',
            noItemDsc: 'text-body-4 text-gray-700',
        };
        const currentPage = ref(1);
        const maxPage = computed(() => store.getters['AccountStore/appliedLectures']?.totalPages || 1);
        const headers = [
            {
                width: '500',
                text: t.translate('table.title'),
                className: 'text-left',
            },
            {
                width: '130',
                text: t.translate('table.method'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.type'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.appliedDate'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.canceledDate'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.applyState'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t_common.translate(`button.cancel`),
                className: 'text-center',
            },
        ];
        const contents = computed(() => store.getters['AccountStore/appliedLectures']?.content || []);
        const blacklist = ref(new UserLectureBlacklistModel());
        onBeforeMount(async () => {
            await fetch();
        });
        async function fetch() {
            await store.dispatch('AccountStore/getAppliedLectures', {
                page: currentPage.value - 1,
                size: PAGE_SIZE,
            });
            blacklist.value = await UserLectureBlacklistModel.get();
        }
        async function changePage(newPage) {
            currentPage.value = newPage;
            await fetch();
        }
        async function cancel(lecture) {
            if (!lecture.canCancel) {
                store.dispatch('AlertStore/showAlertModal', {
                    message: t.translate('modal.appliedNotCanceled'),
                });
                return;
            }
            store.dispatch('AlertStore/showAlertModal', {
                message: t.translate('modal.appliedCancel'),
                onConfirm: async () => {
                    try {
                        await AccountService.deleteLectureCanceled({
                            lectureId: lecture.lectureId,
                            attenderId: lecture.attenderId,
                        });
                        await fetch();
                    }
                    catch (error) {
                        const errorInfo = new ErrorInfo(error.response.data);
                        store.dispatch('AlertStore/showAlertModal', {
                            message: errorInfo.message,
                        });
                    }
                },
            });
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (blacklist.value.restricted)
                    ? (_openBlock(), _createElementBlock("section", {
                        key: 0,
                        class: _normalizeClass(style.section1)
                    }, [
                        _createElementVNode("strong", {
                            class: _normalizeClass(style.subTitle)
                        }, _toDisplayString(_ctx.$t('eduCenter.attend.restricted.guide', {
                            restrictStartAt: _unref(formatDate)(blacklist.value.restrictStartAt),
                            restrictFinishAt: _unref(formatDate)(blacklist.value.restrictFinishAt),
                        })), 3)
                    ], 2))
                    : _createCommentVNode("", true),
                _createElementVNode("section", {
                    class: _normalizeClass(style.section2)
                }, [
                    _createElementVNode("table", {
                        class: _normalizeClass(style.table)
                    }, [
                        _createElementVNode("colgroup", null, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header) => {
                                return _createElementVNode("col", {
                                    key: header.text,
                                    width: header.width
                                }, null, 8, _hoisted_1);
                            }), 64))
                        ]),
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", {
                                class: _normalizeClass(style.thWrapper)
                            }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header) => {
                                    return _createElementVNode("th", {
                                        key: header.text,
                                        class: _normalizeClass([style.th, header.className])
                                    }, _toDisplayString(header.text), 3);
                                }), 64))
                            ], 2)
                        ]),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contents.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: `lecture-${currentPage.value}-${index}-${item.id}`,
                                    class: "first:[&>td]:border-t-0"
                                }, [
                                    _createElementVNode("td", {
                                        class: _normalizeClass(style.td)
                                    }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(style.tdTitleWrapper)
                                        }, [
                                            _createVNode(_component_router_link, {
                                                to: { path: `/attend/detail/${item.lectureId}` },
                                                class: _normalizeClass([style.tdTitle])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.title), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["to", "class"]),
                                            _createElementVNode("div", {
                                                class: _normalizeClass([style.withIcon.wrapper])
                                            }, [
                                                _createVNode(_unref(SpriteIcons), {
                                                    class: _normalizeClass([style.withIcon.icon1]),
                                                    name: "time"
                                                }, null, 8, ["class"]),
                                                _createTextVNode(" " + _toDisplayString(_unref(formatDate)(item.startAt, item.finishAt)), 1)
                                            ], 2)
                                        ], 2)
                                    ], 2),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass([style.withIcon.wrapperCenter])
                                        }, [
                                            _createVNode(_unref(SpriteIcons), {
                                                class: _normalizeClass([style.withIcon.icon2]),
                                                name: item.isOnline ? 'online' : 'offline'
                                            }, null, 8, ["class", "name"]),
                                            _createTextVNode(" " + _toDisplayString(_unref(t_common).translate(`enums.method.${item.method}`)), 1)
                                        ], 2)
                                    ], 2),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, _toDisplayString(_ctx.$t(`eduCenter.attend.target.${item.target}`)), 3),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, _toDisplayString(_unref(moment)(item.appliedAt).format(DATE_FORMAT)), 3),
                                    (item.isCanceled)
                                        ? (_openBlock(), _createElementBlock("td", {
                                            key: 0,
                                            class: _normalizeClass([style.td, style.textCenter])
                                        }, _toDisplayString(_unref(moment)(item.canceledAt).format(DATE_FORMAT)), 3))
                                        : (_openBlock(), _createElementBlock("td", {
                                            key: 1,
                                            class: _normalizeClass([style.td, style.textCenter])
                                        }, "-", 2)),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass([style.withIcon.wrapperCenter])
                                        }, [
                                            _createVNode(_unref(Badge), {
                                                color: item.cancelableState ? 'blue' : 'gray',
                                                type: "outlined"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.getApplyState()), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["color"])
                                        ], 2)
                                    ], 2),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass([style.tdButtonWrapper])
                                        }, [
                                            (item.cancelableState)
                                                ? (_openBlock(), _createBlock(_unref(TextButton), {
                                                    key: 0,
                                                    onClick: ($event) => (cancel(item)),
                                                    "class-name": "shrink-0",
                                                    color: "red",
                                                    "desktop-size": "medium",
                                                    "mobile-size": "medium",
                                                    "icon-class-name": "desktop:size-16",
                                                    "icon-name": "close",
                                                    "icon-position": "left"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t_common).translate(`button.cancel`)), 1)
                                                    ]),
                                                    _: 1
                                                }, 8, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (!item.canCancel && item.isOnline && item.isPrepared)
                                                ? (_openBlock(), _createBlock(_unref(TextButton), {
                                                    key: 1,
                                                    "class-name": "shrink-0",
                                                    color: "blue",
                                                    "desktop-size": "medium",
                                                    "mobile-size": "medium",
                                                    "icon-class-name": "desktop:size-16",
                                                    "icon-name": "check",
                                                    "icon-position": "left"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("a", {
                                                            href: item.meetingUrl,
                                                            target: "_blank"
                                                        }, _toDisplayString(_ctx.$t(`eduCenter.attend.detail.onlineLink`)), 9, _hoisted_2)
                                                    ]),
                                                    _: 2
                                                }, 1024))
                                                : _createCommentVNode("", true)
                                        ], 2)
                                    ], 2)
                                ]));
                            }), 128))
                        ])
                    ], 2),
                    (contents.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(style.noItem)
                        }, [
                            _createElementVNode("p", {
                                class: _normalizeClass(style.noItemDsc)
                            }, _toDisplayString(_unref(t).translate('noData')), 3)
                        ], 2))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("nav", {
                    class: _normalizeClass(style.paginationWrapper)
                }, [
                    _createVNode(_unref(Pagination), {
                        class: "!text-title-4",
                        page: currentPage.value,
                        "total-pages": maxPage.value,
                        "onUpdate:page": changePage
                    }, null, 8, ["page", "total-pages"])
                ], 2)
            ], 64));
        };
    }
});
